var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcActionTerrainSlopeDay({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.1064 20H1.76367L7.31738 8.89258L9.43457 10.5869L10.2295 7.94238L14.627 3.54492L22.1064 20Z",
    fill: "#5714CC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 9L10.5 14L8 12L5 18H19L14 7L12 9Z",
    fill: "url(#paint0_linear_2334_8615)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19 18H15.792L13.5859 7.41309L14 7L19 18Z",
    fill: "url(#paint1_linear_2334_8615)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 14L9 16L8 12L10.5 14Z",
    fill: "url(#paint2_linear_2334_8615)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2334_8615",
    x1: 13,
    y1: 7,
    x2: 13,
    y2: 18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#2EB900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FFDE02"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#FF0122"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.998611,
    stopColor: "#8201FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2334_8615",
    x1: 7.5,
    y1: 9.5,
    x2: 19,
    y2: 18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#2EB900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FFDE02"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#FF0122"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.998611,
    stopColor: "#8201FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2334_8615",
    x1: 7.5,
    y1: 9.5,
    x2: 19,
    y2: 18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#2EB900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FFDE02"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#FF0122"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.998611,
    stopColor: "#8201FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcActionTerrainSlopeDay);
export default __webpack_public_path__ + "static/media/ic_action_terrain_slope_day.34c7e7bd9cd1f19624274ad41917aea6.svg";
export { ForwardRef as ReactComponent };